import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { PhotographerModule } from './app/photographer.module';
import { environment } from './environments/environment';

const supportedBrowsers = require('./supportedBrowsers');
if (environment.production && !supportedBrowsers.test(navigator.userAgent)) {
  alert('Twoje przeglądarka nie jest wspierana.');
}
if (environment.production) {
  enableProdMode();
}

platformBrowser()
  .bootstrapModule(PhotographerModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch((err) => console.error(err));
